  document.querySelectorAll('.show-color-name').forEach(swatch => {
  const label = swatch.getAttribute('data-label');
  const selectedNameEl = document.querySelector('.selected-color-name');
  const originalText = selectedNameEl?.textContent;
  
  swatch.addEventListener('mouseenter', () => {
    if (selectedNameEl && label) {
      selectedNameEl.textContent = label;
    }
  });
  
  swatch.addEventListener('mouseleave', () => {
    if (selectedNameEl && originalText) {
      selectedNameEl.textContent = originalText;
    }
  });
  });




 